export default function MatchGuessSaved() {

  return(
    <div>
      <div className="w-1/2 lg:w-1/4 mx-auto text-center text-sm px-4 py-1 mb-4 bg-green-500 text-white rounded-lg font-semibold cursor-default">
        &#10004;&nbsp;Palpite salvo
      </div>
    </div>
  )
}
